import type { Signal } from '../../../../shared/types';
import { formatDistance } from '../../logic/route';
import { row, section } from '../../ui/components';
import { span } from '../../ui/dom';

export const worthStops = (items: { signal: Signal; meters: number | null }[]): HTMLElement | null =>
  items.length ? section({ title: 'Worth a stop', count: items.length }, items.map(x => row({
    title: span('row__name', x.signal.business_name),
    meta: [[x.signal.address, x.signal.city].filter(Boolean).join(', ') || 'No street address',
      x.meters === null ? '' : ` · ${formatDistance(x.meters)}`],
    href: `#/signals?id=${encodeURIComponent(x.signal.id)}`,
  }))) : null;
